import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

export interface SafeRouterHooks {
  navigate: (path: string, options?: { replace?: boolean; state?: unknown }) => void;
  location: {
    pathname: string;
    search: string;
    state: unknown;
    key: string;
    hash: string;
  };
  params: Record<string, string | undefined>;
  searchParams: URLSearchParams;
  setSearchParams: (params: URLSearchParams | Record<string, string>) => void;
}

export const useSafeNavigate = () => {
  return useNavigate();
};

export const useSafeLocation = () => {
  return useLocation();
};

export const useSafeParams = <
  T extends Record<string, string | undefined> = Record<string, string | undefined>,
>() => {
  return useParams() as T;
};

export const useSafeSearchParams = () => {
  return useSearchParams();
};

export const useSafeRouter = (): SafeRouterHooks => {
  const navigate = useSafeNavigate();
  const location = useSafeLocation();
  const params = useSafeParams();
  const [searchParams, setSearchParams] = useSafeSearchParams();

  return {
    navigate,
    location,
    params,
    searchParams,
    setSearchParams,
  };
};
